<template>
    <div class="d-flex align-items-center">
        <div class="flex-fill text-right">
            <img :src="auth.avatar" class="rounded-circle p-1 border" style="width:100px;">
        </div>
        <div class="flex-fill ml-3">
            <h5 class="font-weight-bold mb-0">{{ auth.name }}</h5>
            <span class="text-muted">{{ auth.phone }}</span><br>
            <span class="text-muted">{{ auth.email }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "Auth",
    props: ['user'],
    computed: {
        auth() {
            if (this.user) {
                return this.user
            }
            return JSON.parse(localStorage.getItem('user'))
        }
    },
}
</script>

<style scoped>

</style>